import apiClient from './apiClient';

export async function listStock(filters = {}) {
  const res = await apiClient.get('/stock-analysis', { params: filters });
  return res.data.data.items;
}

export async function getBreakdown(dimension) {
  const res = await apiClient.get('/stock-analysis/breakdown', { params: { dimension } });
  return res.data.data.items;
}

export async function getDesignOptions() {
  const res = await apiClient.get('/stock-analysis/design-options');
  return res.data.data.items;
}

export async function getSizeOptions() {
  const res = await apiClient.get('/stock-analysis/size-options');
  return res.data.data.items;
}

export async function getReorderSuggestions() {
  const res = await apiClient.get('/stock-analysis/reorder-suggestions');
  return res.data.data.items;
}

export async function getOrderlessStockCards() {
  const res = await apiClient.get('/stock-analysis/orderless-stock');
  return res.data.data.items;
}

export async function getOrderlessStockDetail(sizeId, status) {
  const params = {};
  if (sizeId) params.sizeId = sizeId;
  if (status) params.status = status;
  const res = await apiClient.get('/stock-analysis/orderless-stock/detail', { params });
  return res.data.data;
}

export async function getClassifiedStockDetail(sizeId) {
  const res = await apiClient.get('/stock-analysis/classified-detail', { params: sizeId ? { sizeId } : {} });
  return res.data.data;
}

export async function getDetailAnalysis() {
  const res = await apiClient.get('/stock-analysis/detail');
  return res.data.data;
}

export async function refreshStockAnalysis() {
  const res = await apiClient.post('/stock-analysis/refresh');
  return res.data.data;
}

export async function listOrderlessOrderParties() {
  const res = await apiClient.get('/stock-analysis/orderless-stock/order/parties');
  return res.data.data.items;
}

export async function sendOrderlessOrder(payload) {
  const res = await apiClient.post('/stock-analysis/orderless-stock/order/send', payload);
  return res.data.data;
}

export async function uploadOrderPdf(fileName, dataBase64) {
  const res = await apiClient.post('/stock-analysis/orderless-stock/order/pdf', { fileName, dataBase64 });
  return res.data.data;
}
